"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faChevronLeft_1 = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var IconButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/IconButton"));
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var AccordionSummary_1 = __importDefault(require("shared/components/Accordion/AccordionSummary"));
var DefaultToolItem_1 = __importDefault(require("./DefaultToolItem"));
var TeamHeader_1 = __importDefault(require("./TeamHeader"));
var ToolItem_1 = __importDefault(require("./ToolItem"));
var PREFIX = 'TeamDetails';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    teamHeaderWrapper: "".concat(PREFIX, "-teamHeaderWrapper"),
    innerSectionWrapper: "".concat(PREFIX, "-innerSectionWrapper"),
    teamDetailsWrapper: "".concat(PREFIX, "-teamDetailsWrapper"),
    removeTeamBtn: "".concat(PREFIX, "-removeTeamBtn"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.wrapper)] = {
            border: "1px solid ".concat(theme.palette.grey[400]),
            position: 'relative',
            width: '100%',
            flexShrink: 0,
            borderRadius: 10,
            '&::before': {
                backgroundColor: 'transparent',
            },
            '&.MuiAccordion-root.Mui-expanded': {
                border: "1px solid ".concat(theme.palette.grey[400]),
                borderRadius: 10,
            },
            '& .MuiAccordionSummary-content:first-child': {
                borderRadius: 10,
                margin: 0,
                minHeight: 70,
            },
            '&.MuiAccordion-rounded:last-child': {
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
                borderBottom: "1px solid ".concat(theme.palette.grey[400]),
            },
            '&.MuiAccordion-rounded:first-child': {
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                borderTop: "1px solid ".concat(theme.palette.grey[400]),
            },
        },
        _b[".".concat(classes.teamHeaderWrapper)] = {
            borderRadius: 10,
        },
        _b[".".concat(classes.innerSectionWrapper)] = {
            padding: theme.spacing(0, 2, 2, 2),
            flexDirection: 'column',
        },
        _b["&.".concat(classes.teamDetailsWrapper)] = {
            position: 'relative',
            minHeight: 80,
            marginBottom: theme.spacing(3),
            '&:hover .removeBtn': {
                opacity: 1,
            },
        },
        _b[".".concat(classes.removeTeamBtn)] = {
            position: 'absolute',
            top: '36%',
            left: '-4%',
            zIndex: 2,
            opacity: 0,
            '.fa-w-10': {
                width: theme.spacing(3),
                height: theme.spacing(3),
            },
        },
        _b);
});
var TeamDetails = function (_a) {
    var team = _a.team, teamLeadProfile = _a.teamLeadProfile, teamServices = _a.teamServices, leadEmail = _a.leadEmail, isLeadPopupOpen = _a.isLeadPopupOpen, remove = _a.remove;
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ className: classes.teamDetailsWrapper }, { children: [remove && (0, jsx_runtime_1.jsx)(IconButton_1.default, { icon: faChevronLeft_1.faChevronLeft, onClick: remove, className: (0, clsx_1.default)(classes.removeTeamBtn, 'removeBtn') }), (0, jsx_runtime_1.jsxs)(Accordion_1.default, __assign({ classes: { root: classes.wrapper } }, { children: [(0, jsx_runtime_1.jsx)(AccordionSummary_1.default, __assign({ classes: { root: classes.teamHeaderWrapper } }, { children: (0, jsx_runtime_1.jsx)(TeamHeader_1.default, { team: team, teamLeadProfile: teamLeadProfile, teamServices: teamServices, leadEmail: leadEmail, isLeadPopupOpen: isLeadPopupOpen }) })), (0, jsx_runtime_1.jsxs)(AccordionDetails_1.default, __assign({ classes: { root: classes.innerSectionWrapper } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { borderBottom: "1px solid #e0e0e0", width: "100%", mb: 1 }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (teamServices === null || teamServices === void 0 ? void 0 : teamServices.map(function (s) { return (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, sm: 9, lg: 4 }, { children: (0, jsx_runtime_1.jsx)(ToolItem_1.default, { teamSStats: s }) }), s.id); }))
                                    || __spreadArray([], __read(Array(6).keys()), false).map(function (v) { return (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, sm: 9, lg: 4 }, { children: (0, jsx_runtime_1.jsx)(DefaultToolItem_1.default, {}) }), v); }) }))] }))] }))] })));
};
exports.default = TeamDetails;
